import { useState, useEffect, useRef } from "react";
import api from "../services/api";
import { useToast } from "../context/ToastContext";
import { ALERTAS, LEGENDA_BOLETIM } from "../utilities/constantes";
import { useForm } from "react-hook-form";
import { SCDropdown, SCDialog, SCFieldset, SCInputText, SCInputNumber, SCButton, } from "../components";
import { ReactSortable } from "react-sortablejs";
import { useAuth } from "../providers/auth";
import Loading from "../components/Loading";

const ConfiguracoesBoletim = () => {
  const toast = useToast();
  const tarefa = "ConfiguracoesBoletim";
  const { periodoSelecionado } = useAuth();

  const [loading, setLoading] = useState<boolean>(false);
  const [boletimColunas, setBoletimColunas] = useState<any>();
  const [colunasSelecionadas, setColunasSelecionadas] = useState<any[]>([
    {
      id: "Disciplina",
      value: "",
      fixedText: "Disciplina",
    },
  ]);
  const [colunasBase, setColunasBase] = useState(
    LEGENDA_BOLETIM.map((item: any, index: any) => ({
      id: String(index + 1),
      value: "",
      fixedText: item.descricao,
    }))
  );

  const dt = useRef<any>(null);
  const menu = useRef<any>(null);

  const methods = useForm({});
  const { handleSubmit, control, formState: { errors }, watch, setValue, getValues, } = methods;

  const load = async () => {
    const colunas = await api.get('/boletimColunas', {
      params: {
        EmpresaId: periodoSelecionado?.EmpresaId,
        Ano: periodoSelecionado?.Ano,
        Sequencial: periodoSelecionado?.Sequencial,
      }
    });

    if (colunas.data) {
      const ordered = colunas.data.sort((a: any, b: any) => a.Ordem - b.Ordem);

      const colunasFixas = [
        { id: 'Disciplina', fixedText: 'Disciplina', value: 'Disciplina' },
        ...ordered.map((item: any) => ({
          id: item.Campo,
          fixedText: item.Campo,
          value: item.BoletimColunasCabecalho
        }))
      ];

      const colunasUnicas = colunasFixas.filter(
        (coluna, index, self) =>
          index === self.findIndex((c) => c.id === coluna.id)
      );

      setColunasSelecionadas(colunasUnicas);

      const camposSelecionados = colunasUnicas.map((item) => item.fixedText.toUpperCase());
      const filtros = LEGENDA_BOLETIM
        .filter((legenda: any) => !camposSelecionados.includes(legenda.value.toUpperCase()))
        .map((item: any, index: number) => ({
          id: String(index + 1),
          value: '',
          fixedText: item.value
        }));

      setColunasBase(filtros);
      setBoletimColunas(colunas.data);
    } else {
      setBoletimColunas([]);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleGerarBoletim = async () => {
    setLoading(true)

    const indexDisciplina = colunasSelecionadas.findIndex(item => item.id === 'Disciplina');
    if (indexDisciplina !== 0) {
      toast.showToast({ severity: 'error', summary: 'Erro', detail: 'Posicionamento da Disciplina não pode ser anterior às colunas.' });
      setLoading(false);
      return;
    }

    await Promise.all(
      boletimColunas.map((elemento: any) =>
        api.delete('/boletimColunas', { params: { BoletimId: elemento.BoletimColunasId } })
      )
    );

    await Promise.all(
      colunasSelecionadas
        .filter(item => item.id !== 'Disciplina')
        .map((item, index) => {
          const arrayGravacao = {
            EmpresaId: periodoSelecionado?.EmpresaId,
            Ano: periodoSelecionado?.Ano,
            Sequencial: periodoSelecionado?.Sequencial,
            Ordem: index + 1,
            Campo: item.fixedText,
            BoletimColunasCabecalho: item.value
          };
          return api.post('/boletimColunas', arrayGravacao);
        })
    );

    toast.showToast({ severity: 'success', summary: 'Atenção', detail: ALERTAS.registroGravado });
    setLoading(false)
  };

  return (
    <div className="grid crud-demo">
      <div className="col-12">
        <div className="card">
          <div
            className="flex justify-content-center align-items-center p-2 border-round-top-md text-white"
            style={{ backgroundColor: "#0772B3" }}
          >
            <h5 className="m-0 flex flex-1 align-items-center justify-content-center">
              Configurações de Boletim
            </h5>
          </div>

          {loading ? (<Loading full={false} />) : (
            <>
              <SCFieldset legend="Colunas do Boletim" className="mt-2" style={{ maxHeight: 300, overflow: 'auto' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  <ReactSortable
                    id="colunasSelecionadas"
                    list={colunasSelecionadas}
                    setList={setColunasSelecionadas}
                    className="tableSelectedColumnsBoletim"
                    group="boletim"
                    animation={150}
                    filter=".fixed-disciplina"
                    preventOnFilter={false}
                    style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                    {colunasSelecionadas.map((item, index) => {
                      const isDisciplina = item.id === "Disciplina";

                      return (
                        <div
                          key={item.id}
                          className={`card${isDisciplina ? " fixed-disciplina" : ""}`}
                          style={{
                            width: '110px',
                            height: "110px",
                            padding: 4,
                            margin: 4,
                            borderRadius: 8,
                            backgroundColor: isDisciplina ? "#f5f5f5" : "#87ad91",
                            opacity: isDisciplina ? 0.7 : 1,
                            cursor: isDisciplina ? "not-allowed" : "move",
                            display: "flex",
                            flexDirection: "column",
                            // justifyContent: "space-between",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            gap: "8px"
                          }}
                        >
                          {isDisciplina ? '' : <div>Coluna {index}</div>}
                          <div style={{ fontWeight: "bold" }} className=''>{item.fixedText}</div>
                          {isDisciplina ? '' : <SCInputText
                            style={{ width: "100%", boxSizing: "border-box", textAlign: "center" }}
                            value={item.value}
                            disabled={isDisciplina}
                            maxLength={15}
                            onChange={(e) => {
                              const value = e.target.value.slice(0, 15);
                              if (!isDisciplina) {
                                setColunasSelecionadas((prev) =>
                                  prev.map((el) =>
                                    el.id === item.id ? { ...el, value: value } : el
                                  )
                                );
                              }
                            }}
                          />}
                        </div>
                      );
                    })}
                  </ReactSortable>
                </div>
              </SCFieldset>

              <div className='grid flex justify-content-end pt-3'>
                <div className='col-12 md:col-3'>
                  <SCButton icon="pi pi-plus-o" className="p-button-success" type='submit' style={{ width: '100%' }} label="Gravar Colunas do Boletim" onClick={handleGerarBoletim} />
                </div>
              </div>

              <SCFieldset legend="Colunas disponíveis para formatar o boletim" className="mt-2">
                <div className="grid mt-3">
                  <ReactSortable
                    id="colunasBase"
                    list={colunasBase}
                    setList={setColunasBase}
                    className="grid"
                    group="boletim"
                    animation={150}
                  >
                    {colunasBase.map((item, index) => (
                      <div
                        key={item.id}
                        className="card"
                        style={{
                          width: '110px',
                          // height: "min-content",
                          height: '110px',
                          margin: 4,
                          padding: 4,
                          borderRadius: 8,
                          backgroundColor: "#f8d7da",
                          display: "flex",
                          flexDirection: "column",
                          // justifyContent: "space-between",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          gap: "8px"
                        }}
                      >
                        <div>Coluna {index + 1}</div>
                        <div style={{ fontWeight: "bold" }} className=''>{item.fixedText}</div>
                        <SCInputText
                          style={{ width: "100%", boxSizing: "border-box", textAlign: "center" }}
                          value={item.value}
                          disabled
                        />
                      </div>
                    ))}
                  </ReactSortable>
                </div>
              </SCFieldset>
            </>
          )}

          <SCFieldset legend="Legendas" className="mt-2">
            <div className="grid">
              <div className="col-6">
                <span style={{ fontWeight: "bold" }}>NotaB1</span> = Nota da 1ª
                Bimestral <br />
                <span style={{ fontWeight: "bold" }}>NotaB2</span> = Nota da 2ª
                Bimestral <br />
                <span style={{ fontWeight: "bold" }}>NotaRI</span> = Nota da
                Recuperação Intermediária <br />
                <span style={{ fontWeight: "bold" }}>NotaB3</span> = Nota da 3ª
                Bimestral <br />
                <span style={{ fontWeight: "bold" }}>NotaB4</span> = Nota da 4ª
                Bimestral <br />
                <span style={{ fontWeight: "bold" }}>NotaB5</span> = Nota da 5ª
                Bimestral <br />
                <span style={{ fontWeight: "bold" }}>NotaB6</span> = Nota da 6ª
                Bimestral <br />
                <span style={{ fontWeight: "bold" }}>RecupB1</span> = Nota da
                Recuperação da 1ª Bimestral <br />
                <span style={{ fontWeight: "bold" }}>RecupB2</span> = Nota da
                Recuperação da 2ª Bimestral <br />
                <span style={{ fontWeight: "bold" }}>RecupB3</span> = Nota da
                Recuperação da 3ª Bimestral <br />
              </div>
              <div className="col-6">
                <span style={{ fontWeight: "bold" }}>RecupB4</span> = Nota da
                Recuperação da 4ª Bimestral <br />
                <span style={{ fontWeight: "bold" }}>RecupB5</span> = Nota da
                Recuperação da 5ª Bimestral <br />
                <span style={{ fontWeight: "bold" }}>RecupB6</span> = Nota da
                Recuperação da 6ª Bimestral <br />
                <span style={{ fontWeight: "bold" }}>TotFal</span> = Total de
                Faltas <br />
                <span style={{ fontWeight: "bold" }}>PerFal</span> = Percental
                do Total de Faltas <br />
                <span style={{ fontWeight: "bold" }}>Total</span> = Total das
                notas <br />
                <span style={{ fontWeight: "bold" }}>Média</span> = Média das
                notas <br />
                <span style={{ fontWeight: "bold" }}>MedBim1</span> = Média das
                notas da 1ª Bimestral <br />
                <span style={{ fontWeight: "bold" }}>MedBim2</span> = Média das
                notas da 2ª Bimestral <br />
                <span style={{ fontWeight: "bold" }}>Precisa</span> = Nota que o
                aluno precisa para ser aprovado <br />
              </div>
            </div>
          </SCFieldset>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracoesBoletim;
